export default "__VITE_ASSET__BC3h_znk__"